export default "__VITE_ASSET__oorQt77j__"